import React from "react";
import footerBg from "../../assets/img/footer-img.jpg";
import logo from "../../assets/img/logo.png";
import "./Footer.css";
import { NavLink, useNavigate } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (hash) => {
    navigate(`/#${hash}`, { replace: true });
  };

  return (
    <div>
      <footer
        style={{
          backgroundImage: `url(${footerBg})`,
        }}
      >
        <div className="container">
          <div className="footer-top">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="footer-logo">
                  <img src={logo} alt="logo" />
                  <h3>Masjid Ar-Rahman</h3>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="Information widget-title">
                  <h3>Contact info</h3>
                  <div className="contact-info">
                    <i>
                      <svg
                        viewBox="0 0 64 64"
                        xmlns="http://www.w3.org/2000/svg"
                        data-name="Layer 1"
                      >
                        <path d="m31.965 23.341h-2.992l2.965-2.991c1.005-1.014 1.302-2.534.757-3.873-.526-1.293-1.705-2.11-3.14-2.133-2.196 0-3.982 1.786-3.982 3.981 0 .552.448 1 1 1s1-.448 1-1c0-1.092.889-1.981 2.014-1.981.812.013 1.147.625 1.254.887.193.474.209 1.172-.325 1.71l-4.655 4.695c-.284.287-.368.716-.213 1.089s.519.615.923.615h5.392c.552 0 1-.448 1-1s-.448-1-1-1z" />
                        <path d="m37.2 24.34c0 .552.448 1 1 1s1-.448 1-1v-8.999c0-.429-.274-.811-.681-.948s-.856 0-1.115.342l-4.887 6.428c-.23.303-.269.709-.1 1.05s.516.556.896.556h3.887zm-1.871-3.571 1.871-2.46v2.46z" />
                        <path d="m49.348 26.73h-6.066c-.552 0-1 .448-1 1s.448 1 1 1h4.186l-5.015 7.441c-.309.458-.188 1.08.27 1.388.171.116.366.171.558.171.321 0 .637-.155.83-.441l6.066-9c.207-.307.228-.702.054-1.029-.173-.326-.513-.53-.883-.53z" />
                        <path d="m46.349 15.547c-.488-.257-1.093-.068-1.35.42l-10.128 19.279c-.257.489-.069 1.093.42 1.35.148.078.307.115.464.115.36 0 .708-.194.886-.535l10.128-19.279c.257-.489.069-1.093-.42-1.35z" />
                        <path d="m37.3 2c-11.493 0-21.285 7.795-23.974 18.782l-1.047-1.047c-1.398-1.399-3.838-1.399-5.238 0l-1.206 1.206c-.083.083-.153.173-.233.258-.023.019-.052.027-.074.049-.036.036-.052.083-.082.124-4.698 5.131-4.578 13.119.389 18.086l18.708 18.708c2.552 2.553 5.905 3.829 9.258 3.829s6.706-1.276 9.258-3.829l1.206-1.206c.7-.7 1.085-1.63 1.085-2.619s-.385-1.919-1.085-2.619l-1.047-1.047c10.987-2.689 18.782-12.48 18.782-23.974 0-13.62-11.081-24.7-24.7-24.7zm5.551 53.545-1.206 1.206c-4.326 4.326-11.363 4.325-15.688 0l-18.708-18.708c-3.981-3.981-4.288-10.254-.941-14.601l6.589 6.589c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-6.662-6.662.806-.806c.322-.322.75-.499 1.205-.499s.883.177 1.205.499l6.232 6.231c.664.665.664 1.746 0 2.41l-1.51 1.51c-1.774 1.774-1.774 4.66 0 6.434l10.671 10.671c1.529 1.53 3.883 1.733 5.64.625l6.732 6.732c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-6.648-6.648.806-.806c.664-.664 1.746-.664 2.41 0l6.239 6.24c.322.322.499.75.499 1.205s-.177.883-.499 1.205zm-1.317-6.555-3.508-3.508c-1.443-1.444-3.793-1.443-5.238 0l-1.51 1.51c-.995.995-2.612.994-3.606 0l-10.671-10.671c-.994-.994-.994-2.612 0-3.606l1.51-1.51c1.444-1.444 1.444-3.794 0-5.238l-3.501-3.5c2.026-10.726 11.311-18.466 22.29-18.466 12.517 0 22.7 10.183 22.7 22.7 0 10.978-7.74 20.264-18.466 22.29z" />
                      </svg>
                    </i>
                    <div>
                      <h5>Phone no:</h5>
                      <a href="callto:+254(98)2156213">+254 (98) 2156 213</a>
                    </div>
                  </div>
                  <div className="contact-info">
                    <i>
                      <svg
                        fill="none"
                        height="48"
                        viewBox="0 0 48 48"
                        width="48"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          clipRule="evenodd"
                          fill="rgb(0,0,0)"
                          fillRule="evenodd"
                        >
                          <path d="m9 10c-1.65685 0-3 1.3431-3 3v22c0 1.6569 1.34315 3 3 3h30c1.6569 0 3-1.3431 3-3v-17c0-.5523.4477-1 1-1s1 .4477 1 1v17c0 2.7614-2.2386 5-5 5h-30c-2.76142 0-5-2.2386-5-5v-22c0-2.7614 2.23858-5 5-5h22c.5523 0 1 .44772 1 1s-.4477 1-1 1z" />
                          <path d="m13.2929 16.2929c.3905-.3905 1.0237-.3905 1.4142 0l8.5858 8.5858c.3905.3905 1.0237.3905 1.4142 0l8.5858-8.5858c.3905-.3905 1.0237-.3905 1.4142 0s.3905 1.0237 0 1.4142l-8.5858 8.5858c-1.1716 1.1716-3.071 1.1716-4.2426 0l-8.5858-8.5858c-.3905-.3905-.3905-1.0237 0-1.4142z" />
                          <path d="m40 11c1.1046 0 2-.8954 2-2 0-1.10457-.8954-2-2-2s-2 .89543-2 2c0 1.1046.8954 2 2 2zm0 2c2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4s-4 1.79086-4 4c0 2.2091 1.7909 4 4 4z" />
                        </g>
                      </svg>
                    </i>
                    <div>
                      <h5>Email Address:</h5>
                      <a href="mailto:username@domain.com">
                        username@domain.com
                      </a>
                    </div>
                  </div>
                  <div className="contact-info">
                    <i>
                      <svg
                        id="LOCATION"
                        height="512"
                        viewBox="0 0 1800 1800"
                        width="512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <g>
                            <path
                              d="m899.993 1556.267 441.512-441.511c8.202-7.819 26.127-26.384 26.893-27.184l.36-.383c110.946-118.997 172.046-274.141 172.046-436.851 0-353.342-287.463-640.805-640.803-640.805-353.342 0-640.805 287.463-640.805 640.805 0 162.714 61.1 317.857 172.038 436.851zm.008-1485.108c319.355 0 579.179 259.818 579.179 579.18 0 146.968-55.159 287.114-155.315 394.639-5.202 5.387-19.292 19.873-25.095 25.383l-398.764 398.739-424.049-424.315c-100.055-107.499-155.137-247.556-155.137-394.446 0-319.362 259.814-579.18 579.181-579.18z"
                              fill="rgb(0,0,0)"
                            />
                          </g>
                          <g>
                            <path
                              d="m998.745 225.279c110.577 0 325.781 120.91 325.781 342.553 0 17.018 13.789 30.812 30.812 30.812 17.014 0 30.812-13.794 30.812-30.812 0-115.37-50.989-222.331-143.563-301.184-73.464-62.566-169.175-102.994-243.842-102.994-17.014 0-30.812 13.794-30.812 30.813s13.798 30.812 30.812 30.812z"
                              fill="rgb(0,0,0)"
                            />
                          </g>
                          <g>
                            <path
                              d="m1286.716 1361.056c-24.003-9.809-49.854-18.548-77.134-26.264l-50.474 50.478c148.765 35.502 240.488 98.79 240.488 157.599 0 87.962-205.171 185.974-499.596 185.974-294.417 0-499.597-98.012-499.597-185.974 0-58.805 91.723-122.097 240.488-157.599l-50.478-50.478c-27.271 7.716-53.126 16.455-77.121 26.264-112.537 45.995-174.513 110.563-174.513 181.813s61.977 135.817 174.513 181.813c103.793 42.422 241.128 65.785 386.708 65.785 145.582 0 282.921-23.363 386.715-65.785 112.536-45.995 174.504-110.563 174.504-181.813s-61.967-135.818-174.503-181.813z"
                              fill="rgb(0,0,0)"
                            />
                          </g>
                          <g>
                            <path
                              d="m901.771 945.221c-171.172 0-310.434-139.256-310.434-310.425s139.262-310.426 310.434-310.426 310.434 139.256 310.434 310.425-139.262 310.426-310.434 310.426zm0-559.226c-137.193 0-248.809 111.612-248.809 248.801s111.616 248.801 248.809 248.801c137.192 0 248.809-111.612 248.809-248.801s-111.616-248.801-248.809-248.801z"
                              fill="rgb(0,0,0)"
                            />
                          </g>
                        </g>
                      </svg>
                    </i>
                    <h5>98-10 211th street, Queens Village, NY 11429</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                  <ul>
                    <li>
                      <a
                        href="#courses"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigation("courses");
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} /> Courses
                      </a>
                    </li>
                    <li>
                      <a
                        href="#sura"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigation("sura");
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} /> Surah
                      </a>
                    </li>
                    <li>
                      <a
                        href="#services"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigation("services");
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} /> Services
                      </a>
                    </li>
                    <li className="footer-link-list">
                      <NavLink to="/scholars">
                        <FontAwesomeIcon icon={faChevronRight} /> Scholars
                      </NavLink>
                      {/* <a
                        href="#scholar"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigation("scholar");
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} /> Our Scholar
                      </a> */}
                    </li>
                    <li className="pb-0">
                      <a
                        href="#sura"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNavigation("sura");
                        }}
                      >
                        <FontAwesomeIcon icon={faChevronRight} />
                        Donation
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="wpo-lower-footer">
            <p>
              Copyright ©
              <a href="#">
                <b>Mashjid Ar-Rahman</b>
              </a>
              {new Date().getFullYear()} . All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
